import { render } from "./InFocusComponent.vue?vue&type=template&id=6797cf1b&scoped=true"
const script = {}

import "./InFocusComponent.vue?vue&type=style&index=0&id=6797cf1b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6797cf1b"

export default script